"use server";
import { newId, notify, rateLimited, type FormResult } from "@cw/forms";
import { clientKey } from "@/lib/client-key";
import { createContactService } from "@/lib/contact-service";

function fromForm(fd: FormData): Record<string, string> {
  const o: Record<string, string> = {};
  for (const [k, v] of fd.entries()) if (typeof v === "string") o[k] = v;
  return o;
}

export async function submitContact(_prev: FormResult | null, fd: FormData): Promise<FormResult> {
  return submit(fromForm(fd), await clientKey("contact"));
}

const submit = createContactService({
  notify,
  newId,
  isRateLimited: (key) => rateLimited(key, 10),
  onDeliveryFailure: (id) => {
    console.error(`[contact] delivery failed for reference ${id}; SMTP did not confirm delivery`);
  },
});
